module.exports = __webpack_public_path__ + "static/img/ic_serviceflow_b.dbaac0a0.png";